export default __webpack_public_path__ + "static/media/inrest-table1.f8e225a0.png";